module.exports = __webpack_public_path__ + "img/icon_pocket.e37b0837.svg";